import { findDocumentElement } from './DomUtils';

const DIALOG_CLASSNAME = 'grb-tour-dialog';

const HighlightAction = {
  start(step) {
    const elt = findDocumentElement(step.element);
    const ref = findDocumentElement(step.ref || [`.${DIALOG_CLASSNAME}`, '.MuiBackdrop-root']);
    if (elt) {
      const rect = elt.getBoundingClientRect();
      const overlayRect = ref.getBoundingClientRect();
      const center = {
        x: rect.left + (rect.width / 2) - overlayRect.left,
        y: rect.top + (rect.height / 2) - overlayRect.top,
      };
      const w = rect.width / 2;
      const h = rect.height / 2;
      const gradiant = `radial-gradient(ellipse ${w - 5}px ${h - 5}px at ${center.x}px ${center.y}px, transparent ${w - 5}px ${h - 5}px, rgba(0, 0, 0, 0.5) ${w + 20}px ${h + 20}px, rgba(0, 0, 0, 0.5) 100% 100%)`;
      const overlay = findDocumentElement([`.${DIALOG_CLASSNAME}`, '.MuiBackdrop-root']);
      overlay.style.backgroundColor = 'transparent';
      overlay.style.backgroundImage = gradiant;
    }
  },
  stop() {
    const overlay = findDocumentElement([`.${DIALOG_CLASSNAME}`, '.MuiBackdrop-root']);
    overlay.style.backgroundImage = 'none';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
  },
};

export { HighlightAction as default, DIALOG_CLASSNAME };
